import { Component } from '@angular/core';
import { TreeModel, TreeModelSettings } from 'ng2-tree';

export class ScopeSelectorTreeModel {
  getAllClients(data): any {
    var node = [];
    data.forEach(client => {
      node.push(client);
    });
    return node;
  }
  getDeliveryConstructsHierarchyFDS(data): any {
    var node = {
      id: data.ScopeSelectorData.DeliveryConstructUId,
      value: data.ScopeSelectorData.DeliveryConstruct,
      dispalyValue: data.ScopeSelectorData.DeliveryConstruct,
      children: [],
      settings: {
        isCollapsedOnInit: false,
        rightMenu: false
      },

      // icon: data.Client.ImageBinary ? 'data:image/jpeg;base64,' + data.Client.ImageBinary : 'assets/images/scope-opportunity.png',
      nodeType: data.ScopeSelectorData.DeliveryConstructType,
      Status: data.ScopeSelectorData.Status,
      WorkstreamTypeID: data.ScopeSelectorData.WorkstreamTypeID,
      ParentDeliveryConstructUId: data.ScopeSelectorData.ParentDeliveryConstructUId,
      ParentDeliveryConstructType: data.ScopeSelectorData.ParentDeliveryConstructType,
      ClientName: data.ScopeSelectorData.ClientName
    };

    data.ScopeSelectorData.Children.forEach(dc => {
      var temp = this.getNode(dc, data.ClientName, data.InfraWorkStreamIDs);
      node.children.push(temp);
    });
    // node.children = data.ScopeSelectorData[0].Children;

    return node;
  }
  getDeliveryConstructsHierarchy(data): any {
    var node = {
      id: data.ScopeSelectorDataFds.DeliveryConstructUId,
      value: data.ScopeSelectorDataFds.DeliveryConstruct,
      dispalyValue: data.ScopeSelectorDataFds.DeliveryConstruct,
      children: [],
      settings: {
        isCollapsedOnInit: false,
        rightMenu: false
      },

      // icon: data.Client.ImageBinary ? 'data:image/jpeg;base64,' + data.Client.ImageBinary : 'assets/images/scope-opportunity.png',
      nodeType: data.ScopeSelectorDataFds.DeliveryConstructType,
      Status: data.ScopeSelectorDataFds.Status,
      WorkstreamTypeID: data.ScopeSelectorDataFds.WorkstreamTypeID,
      ParentDeliveryConstructUId: data.ScopeSelectorDataFds.ParentDeliveryConstructUId,
      ParentDeliveryConstructType: data.ScopeSelectorDataFds.ParentDeliveryConstructType,
      ClientName: data.ScopeSelectorDataFds.ClientName
    };

    data.ScopeSelectorDataFds.Children.forEach(dc => {
      var temp = this.getNode(dc, data.ClientName, data.InfraWorkStreamIDs);
      node.children.push(temp);
    });
    // node.children = data.ScopeSelectorData[0].Children;

    return node;
  }
  getDeliveryConstructsHierarchyForPAM(data): any {   
    var node = {
      id: data.DeliveryConstructUId,
      value: data.DeliveryConstruct,
      dispalyValue: data.DeliveryConstruct,
      children: [],
      settings: {
        isCollapsedOnInit: false,
        rightMenu: false
      },

      // icon: data.Client.ImageBinary ? 'data:image/jpeg;base64,' + data.Client.ImageBinary : 'assets/images/scope-opportunity.png',
      nodeType: data.DeliveryConstructType,
      Status: data.Status,
      WorkstreamTypeID: data.WorkstreamTypeID,
      ParentDeliveryConstructUId: data.ParentDeliveryConstructUId,
      ParentDeliveryConstructType: data.ParentDeliveryConstructType,
      ParentE2EUID: data.ParentE2EUID
    };

    data.Children.forEach(dc => {
      var temp = this.getNode(dc, data.ClientName, data.InfraWorkStreamIDs);
      node.children.push(temp);
    });
    // node.children = data.ScopeSelectorData[0].Children;

    return node;
  }
  public getNode(dc, clientName, infraworkstreamids): any {
    var node = {
      id: dc.DeliveryConstructUId,
      value: this.getCustomValue(dc, infraworkstreamids),
      dispalyValue: dc.DeliveryConstruct,
      children: [],
      settings: {
        rightMenu: false,
        //selectionAllowed: (dc.Status !== "Closed") ? true : false,
        isCollapsedOnInit: true,
        keepNodesInDOM: true,
        static: false
      },

      //icon: dc.ImageBinary ? 'data:image/jpeg;base64,' + dc.ImageBinary : 'assets/images/scope-opportunity.png',
      nodeType: dc.DeliveryConstructType,
      Status: dc.Status,
      WorkstreamTypeID: dc.WorkstreamTypeID,
      ParentDeliveryConstructUId: dc.ParentDeliveryConstructUId,
      ParentDeliveryConstructType: dc.ParentDeliveryConstructType,
      ParentE2EUID:dc.ParentE2EUID,
      clientUId: clientName,
      clientName: clientName
    };

    if (dc.Children != undefined && dc.Children.length > 0) {
      dc.Children.forEach(dc1 => {
        var temp = this.getNode(dc1, clientName, infraworkstreamids);
        node.children.push(temp);
      });
    }
    //node.children.push(dc.Children);
    return node;
  }
  getCustomValue(dc, infraworkstreamids) {
    let dcValue;
    if (dc.WorkstreamTypeID != 0 && dc.WorkstreamTypeID != null && infraworkstreamids != undefined && infraworkstreamids != null && infraworkstreamids.length > 0) {
      infraworkstreamids.forEach(element => {
        if (element == dc.WorkstreamTypeID) {
          dcValue = "[Infra]" + dc.DeliveryConstruct;
        }
        else {
          dcValue = dc.DeliveryConstruct;
        }
      });
    }
    else if (dc.Status === "Closed") {
      dcValue = "<span style='font-style: italic'>[" + dc.Status + "]<span>" + dc.DeliveryConstruct;
    }
    else {
      dcValue = dc.DeliveryConstruct;
    }
    return dcValue;
  }
  getLeftDeliveryConstructsHierarchy(data): any {
    var node = {
      id: data.DeliveryStructureData.DeliveryConstructUId,
      value: data.DeliveryStructureData.DeliveryConstruct,
      dispalyValue: data.DeliveryStructureData.DeliveryConstruct,
      children: [],
      settings: {
        isCollapsedOnInit: false,
        rightMenu: false,
        keepNodesInDOM: true,
        static: false
      },

      // icon: data.Client.ImageBinary ? 'data:image/jpeg;base64,' + data.Client.ImageBinary : 'assets/images/scope-opportunity.png',
      nodeType: data.DeliveryStructureData.DeliveryConstructType,
      Status: data.DeliveryStructureData.Status,
      WorkstreamTypeID: data.DeliveryStructureData.WorkstreamTypeID,
      ParentDeliveryConstructUId: data.DeliveryStructureData.ParentDeliveryConstructUId,
      ParentDeliveryConstructType: data.DeliveryStructureData.ParentDeliveryConstructType,
    };

    data.DeliveryStructureData.Children.forEach(dc => {
      var temp = this.getNode(dc, data.ClientName, data.InfraWorkStreamIDs);
      node.children.push(temp);
    });
    // node.children = data.ScopeSelectorData[0].Children;

    return node;
  }
  getClients(data): any {
    var node = {
      id: 'root',
      value: "",
      children: [],
      settings: {
        rightMenu: false,
        isCollapsedOnInit: false, //root note should NOT be collapsed !
      },

      //icon: data.ImageBinary ? 'data:image/jpeg;base64,' + data.ImageBinary : '../assets/images/scope-opportunity.png',
      icon: '',
      nodeType: 'client'
    }

    data.forEach(client => {
      var c = {
        id: client.ClientUId,
        value: client.Name,
        children: [],
        settings: {
          rightMenu: false,
          isCollapsedOnInit: true,
        },

        icon: client.ImageBinary ? 'data:image/jpeg;base64,' + client.ImageBinary : 'assets/images/scope-opportunity.png',
        nodeType: 'client'
      }
      node.children.push(c);
    });

    return node;
  }
}
